module.exports = __webpack_public_path__ + "img/stray-pausemenu.ab634ac5.jpg";